export function useCatalogCache({ store, ttl = 5 * 60 * 1000 } = {}) {
  const dataKey = 'catalogState'

  function getCurrentPath() {
    let search = window.location.search

    if (search === '') {
      search = '?search=&order_by=popularity_desc'
    }

    return window.location.pathname + search
  }

  function save() {
    const state = {
      products: store.getters['products/productsList'],
      canLoadMore: store.getters['products/canLoadMore'],
      perPage: store.getters['products/perPage'],
      scrollY: window.scrollY,
      timestamp: Date.now(),
      path: getCurrentPath(),
    }

    sessionStorage.setItem(dataKey, JSON.stringify(state))
  }

  function restore() {
    const saved = JSON.parse(sessionStorage.getItem(dataKey) || '{}')

    if (
      !saved.timestamp ||
      Date.now() - saved.timestamp > ttl ||
      !saved.products?.length ||
      saved.path !== getCurrentPath()
    )
      return null

    store.commit('products/setProducts', saved.products)
    store.commit('products/setCanLoadMore', saved.canLoadMore)
    store.commit('products/setPerPage', saved.perPage)

    sessionStorage.removeItem(dataKey)

    return saved
  }

  return {
    save,
    restore,
  }
}
